// extracted by mini-css-extract-plugin
export var brand = "Header-module--brand--81b5d";
export var button = "Header-module--button--2246f";
export var container = "Header-module--container--d1b7f";
export var controls = "Header-module--controls--7ab54";
export var logo = "Header-module--logo--edb3a";
export var mainSection = "Header-module--mainSection--05095";
export var tel = "Header-module--tel--df8ec";
export var topSection = "Header-module--topSection--fe80b";